var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRebg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 1054,
    viewBox: "0 0 1512 1054",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1054V0H1514V799.517L0 1054Z",
    fill: "url(#paint0_linear_451_21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_451_21",
    x1: 757,
    y1: 0,
    x2: 757,
    y2: 1054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00318F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000E29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebg);
export default __webpack_public_path__ + "static/media/rebg.ce2df404880daef231f4551bc1c740bc.svg";
export { ForwardRef as ReactComponent };